import {
  Button,
  Drawer,
  Form,
  Space,
  TimePicker,
  Typography,
  DatePicker,
  Select,
} from "antd";
import axios from "axios";
import React, { useContext, useState } from "react";
import { NotificationInfo } from "../../../../context";
import moment from "moment";
import dayjs from "dayjs";

const EditLogs = ({ open, close, rerun, selectedData }) => {
  const { rerunNotif } = useContext(NotificationInfo);
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const [timeIn, setTimeIn] = useState(
    selectedData.day_sub_status !== "absent"
      ? selectedData.current_time_in !== null
        ? selectedData.current_time_in
        : null
      : null
  );
  const [timeOut, setTimeOut] = useState(
    selectedData.day_sub_status !== "absent"
      ? selectedData.current_time_out !== null
        ? selectedData.current_time_out
        : null
      : null
  );
  const [daySubStatus, setDaySubStatus] = useState(
    selectedData.day_sub_status !== null ? selectedData.day_sub_status : null
  );
  const [currentDate, setCurrentDate] = useState(
    selectedData.current_date !== null
      ? dayjs(selectedData.current_date, "YYYY-MM-DD")
      : null
  );

  const handleEditLog = (values) => {
    const formdata = new FormData();
    formdata.append("id", selectedData !== null ? selectedData.id : "");
    formdata.append("current_time_in", timeIn !== null ? timeIn : "");
    formdata.append("current_time_out", timeOut !== null ? timeOut : "");
    formdata.append(
      "day_sub_status",
      daySubStatus !== null ? daySubStatus : ""
    );
    formdata.append("current_date", currentDate !== null ? currentDate : "");

    setLoading(true);

    axios
      .post("user/merchant/update/edit-log", formdata)
      .then((response) => {
        const data = response.data;
        if (data.message === "success") {
          rerunNotif("success", "Edited log successfully.");
          setTimeout(() => {
            rerun();
            setLoading(false);
            close();
          }, 1000);
        }
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  return (
    <Drawer
      title="Edit Log"
      onClose={close}
      open={open}
      bodyStyle={{
        paddingBottom: 80,
      }}
    >
      {selectedData !== null && (
        <Form
          form={form}
          layout="vertical"
          name="edit-logs"
          initialValues={{
            current_time_in:
              selectedData.current_time_in !== null
                ? dayjs(selectedData.current_time_in, "HH:mm:ss")
                : null,
            current_time_out:
              selectedData.current_time_out !== null
                ? dayjs(selectedData.current_time_out, "HH:mm:ss")
                : null,

            day_sub_status:
              selectedData.day_sub_status !== null
                ? selectedData.day_sub_status
                : "",
            current_date:
              selectedData.current_date !== null
                ? dayjs(selectedData.current_date, "YYYY-MM-DD")
                : null,
          }}
          onFinish={handleEditLog}
          autoComplete="off"
        >
          <Space direction="vertical" style={{ width: "100%", margin: 0 }}>
            <Form.Item
              name="day_sub_status"
              label="Status"
              rules={[
                {
                  required: true,
                  message: "Required",
                },
              ]}
            >
              <Select
                size="large"
                onChange={(e) => {
                  setDaySubStatus(e);
                }}
              >
                <Select.Option value={"present"}>Present</Select.Option>
                <Select.Option value={"absent"}>Absent</Select.Option>
              </Select>
            </Form.Item>

            <Form.Item
              name="current_date"
              label="Date"
              rules={[
                {
                  required: true,
                  message: "Required",
                },
              ]}
            >
              <DatePicker
                format={"MM/DD/YYYY"}
                size="large"
                style={{ width: "100%" }}
                onChange={(e) =>
                  setCurrentDate(moment(new Date(e)).format("YYYY-MM-DD"))
                }
              />
            </Form.Item>

            {daySubStatus === "present" && (
              <>
                <Form.Item
                  name="current_time_in"
                  label="Time in"
                  rules={[
                    {
                      required: true,
                      message: "Required",
                    },
                  ]}
                >
                  <TimePicker
                    format={"HH:mm"}
                    onChange={(value, dateString) => {
                      if (dateString !== "") {
                        var date = `2023-11-23 ${dateString}:00`;
                        var finalDate = moment(
                          `${date.replace(" ", "T")}.000000Z`
                        )
                          .utc()
                          .format("HH:mm:ss");
                        setTimeIn(finalDate);
                      } else {
                        setTimeIn(null);
                      }
                    }}
                    size="large"
                    required
                    style={{ width: "100%" }}
                  />
                </Form.Item>

                <Form.Item
                  name="current_time_out"
                  label="Time out"
                  rules={[
                    {
                      required: false,
                      message: "Required",
                    },
                  ]}
                >
                  <TimePicker
                    format={"HH:mm"}
                    onChange={(value, dateString) => {
                      if (dateString !== "") {
                        var date = `2023-11-23 ${dateString}:00`;
                        var finalDate = moment(
                          `${date.replace(" ", "T")}.000000Z`
                        )
                          .utc()
                          .format("HH:mm:ss");
                        setTimeOut(finalDate);
                      } else {
                        setTimeOut(null);
                      }
                    }}
                    size="large"
                    required
                    style={{ width: "100%" }}
                  />
                </Form.Item>
              </>
            )}
          </Space>

          <Form.Item style={{ marginTop: "20px" }}>
            <Button
              type="primary"
              //   loading={loading}
              htmlType="submit"
              style={{ width: "100%", borderRadius: "20px" }}
              disabled={timeIn === null}
            >
              {loading ? "Loading" : "Update"}
            </Button>
          </Form.Item>
        </Form>
      )}
    </Drawer>
  );
};

export default EditLogs;
